import { getFactoryAlbums, getPage, type ContentPage, type FactoryAlbum } from './api';
import type { Locale } from '@jws/shared';

type CompanyPageSlug = 'factory' | 'quality';

const pageRequests = new Map<string, Promise<ContentPage>>();
const albumRequests = new Map<Locale, Promise<FactoryAlbum[]>>();

function pageKey(locale: Locale, slug: CompanyPageSlug) {
  return `${locale}:${slug}`;
}

export function loadCompanyPage(locale: Locale, slug: CompanyPageSlug): Promise<ContentPage> {
  const key = pageKey(locale, slug);
  const existing = pageRequests.get(key);
  if (existing) return existing;

  const request = getPage(locale, slug).catch((reason) => {
    pageRequests.delete(key);
    throw reason;
  });
  pageRequests.set(key, request);
  return request;
}

export function loadFactoryAlbums(locale: Locale): Promise<FactoryAlbum[]> {
  const existing = albumRequests.get(locale);
  if (existing) return existing;

  const request = getFactoryAlbums(locale).catch((reason) => {
    albumRequests.delete(locale);
    throw reason;
  });
  albumRequests.set(locale, request);
  return request;
}

export function prefetchCompanyContent(locale: Locale): void {
  void loadCompanyPage(locale, 'factory');
  void loadCompanyPage(locale, 'quality');
  void loadFactoryAlbums(locale);
}
